<template>
    <div style="max-height:75vh; overflow-y:auto; overflow-y:none">
        <div class="card mb-2" v-for="(plan, index) in treatments" :key="index">
            <div class="card-body p-3 mb-0" v-if="plan.treatments.length>0">
                <div class="row">
                    <div class="col-1">
                        <div class="h2">#{{plan.tooth}}</div>
                        <parts v-model="plan.parts" readonly="true" style="width:50px;"></parts>
                    </div>
                    <div class="col-3">
                        <div class="h4" v-for="icd in plan.icd" :key="icd._id">
                            <strong>{{icd.code}}</strong>
                            - {{icd.label}}
                        </div>
                        <div>
                            <button
                                class="btn btn-white btn-sm"
                                @click="openModal({ id: 'ScheduleModal', model:plan });"
                            >
                                {{ $t('Schedule')}}
                                <i class="fe fe-calendar"></i>
                            </button>
                            <div class="mt-4" v-for="(appointmentId, index) in plan.appointments" :key="index">
                                <div class="small muted" v-if="appointment(appointmentId)">
                                    {{ appointment(appointmentId).startAt | moment('DD MMMM, YYYY ')}}
                                    <span
                                        class="text-muted"
                                    >[{{ appointment(appointmentId).startAt | moment('LT')}}-{{ appointment(appointmentId).endAt | moment('LT')}}]</span>
                                    <status-badge :status="appointment(appointmentId).status"></status-badge>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card card-inactive mb-2 border-info border-dashed" v-if="plan.notes">
                            <div class="card-body p-2">
                                <div class="row align-items-center">
                                    <div class="col-auto">
                                        <i class="fe fe-message-circle h1 text-muted"></i>
                                    </div>
                                    <div class="col ml-n3">{{ plan.notes }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="card card-inactive mb-2" v-for="treatment in plan.treatments" :key="treatment._id">
                            <div class="card-body p-2">
                                <div class="row">
                                    <div class="col-auto">
                                        {{treatment.label}}
                                        <div class="row text-muted small">
                                            <div class="col-auto">{{ treatment.duration | duration }}</div>
                                            <div class="col-auto">
                                                <money :value="treatment.price" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col"></div>
                                    <div class="col-auto small">
                                        <user :user="treatment.user" avatar="true" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <schedule-modal id="ScheduleModal" :data="model" />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'
import duration from '@/filters/duration.js';
import Money from '@/components/Money';
import Parts from '@/components/Tooth/Parts';
import StatusBadge from '@/components/StatusBadge'
import User from '@/components/User';
import ScheduleModal from '../Schedule'

export default {
    props: ['treatmentPlan'],
    mixins: [modalMixins],
    filters: { duration },
    components: {
        User,
        Money,
        Parts,
        StatusBadge,
        ScheduleModal,
    },
    computed: {
        ...mapGetters('icd', { getIcdFromStore: 'get' }),
        ...mapGetters('appointment', { appointment: 'get' }),

        treatments() {

            let items = [], appointmentsToFetch = [];
            for (let i in this.treatmentPlan) {
                let item = this.treatmentPlan[i];

                if (Object.keys(item).length > 0) {
                    item.appointments = item.appointments || [];

                    if (item.appointments.length > 0) {
                        item.appointments.forEach(appointmentId => {
                            appointmentsToFetch.push(appointmentId);
                        });
                    }
                    items.push(item);
                }

            }
            if (appointmentsToFetch.length > 0) {
                this.fetchAppointments({ query: { _id: { $in: appointmentsToFetch } } });
            }
            return items;
        },
    },
    methods: {
        ...mapActions('icd', { fetchIcd: 'find' }),
        ...mapActions('appointment', { fetchAppointments: 'find' }),


        getIcd(icd) {

            return this.getIcdFromStore(icd);
        },
        fetchIcdTree(id) {

            return this.fetchIcd({ query: { _id: { $in: id } } }).then(result => {
                result.data.map(async item => {
                    item.children = await this.fetchChilds(item._id).then(result => result.data);
                });

            });
        },
        fetchChilds(parentId) {
            return this.fetchIcd({ query: { parentId: { $in: parentId } } });
        }
    },
    created() {

        // this.treatmentPlan.forEach(async item => {
        //     this.fetchIcdTree(item.icd);

        //     // this.fetchIcd({ query: { _id: { $in: item.icd } } });

        //     // item.icds = await this.fetchIcd({ query: { _id: { $in: item.icd } } }).then(result => {
        //     //     // item.icds = result.data;
        //     //     return result.data;
        //     //     // if (result.total >= 0) return;
        //     //     // result.data.map(icd => {
        //     //     //     this.fetchIcd({ query: { parentId: icd._id } }).then(childResult => {
        //     //     //         icd.childs = childResult.data;
        //     //     //     });
        //     //     // });
        //     // });
        //     // return item;

        // })

    }


}
</script>

<style>

</style>
